module.exports = __webpack_public_path__ + "static/media/print-tip.4747cde8.mp3";